import React, { useState } from 'react';
import { Package, Settings, MessageSquare } from 'lucide-react';
import ProductsAdmin from '../components/ProductsAdmin';
import SettingsAdmin from '../components/SettingsAdmin';
import TestimonialsAdmin from '../components/TestimonialsAdmin';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('products');

  return (
    <div className="admin-container">
      <div className="container">
        <h1 className="admin-main-title">Admin Dashboard</h1>
        
        <div className="admin-tabs">
          <button
            className={`admin-tab ${activeTab === 'products' ? 'active' : ''}`}
            onClick={() => setActiveTab('products')}
          >
            <Package size={20} />
            Products
          </button>
          <button
            className={`admin-tab ${activeTab === 'settings' ? 'active' : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            <Settings size={20} />
            Settings
          </button>
          <button
            className={`admin-tab ${activeTab === 'testimonials' ? 'active' : ''}`}
            onClick={() => setActiveTab('testimonials')}
          >
            <MessageSquare size={20} />
            Testimonials
          </button>
        </div>

        <div className="admin-tab-content">
          {activeTab === 'products' && <ProductsAdmin />}
          {activeTab === 'settings' && <SettingsAdmin />}
          {activeTab === 'testimonials' && <TestimonialsAdmin />}
        </div>
      </div>
    </div>
  );
};

export default Admin;
